import Vue from 'vue';
import Router from 'vue-router';
import Lists from '@/components/Lists';
import SingleFile from '@/components/SingleFile';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/archivo/:slug',
      name: 'single',
      component: SingleFile,
    },
    {
      path: '/:type?/:slug?',
      name: 'home',
      component: Lists,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js